import { Box, Grid, Typography } from '@mui/material'

type Props = {
  title?: string
  action?: React.ReactNode | React.ReactNode[]
}

export const AdminDataGridTitle = ({ action, title }: Props) => {
  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        padding: 2,
        color: 'white',
      }}
    >
      <Grid container sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Grid>
          <Typography component="h3" variant="h3">
            {title}
          </Typography>
        </Grid>
        {action && <Grid>{action}</Grid>}
      </Grid>
    </Box>
  )
}
